<template>
  <div>
    <div v-if="loading">
      <Spin size="large" />
    </div>
    <div v-else>
      <RoomHeader
        :roomId="roomInfos.id"
        :roomName="roomInfos.displayName" />
      <ActionBody />
    </div>
  </div>
</template>

<script>
import RoomHeader from './RoomHeader'
import ActionBody from './ActionBody'
import { Spin } from 'ant-design-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {RoomHeader, ActionBody, Spin},
  computed: {
    ...mapGetters({
      loading: 'isLoading',
      roomInfos: 'room',
    })
  },
  mounted: function () {
    this.getRoom()
  },
  methods: {
    getRoom() {
      const roomId = this.$route.query.roomId
      if (!roomId) {
        this.$store.dispatch('triggerError')
        return
      }

      this.$store.dispatch('signInAndGetRoom', roomId)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ant-btn {
  margin-bottom: .5rem;
}
</style>
